module.exports = __webpack_public_path__ + "static/media/thunderstorm-moon.3cf11078.svg";